import React from "react";
import { IMAGES } from "../assets/img/ImageIndex";
import { Link } from "react-router-dom";
import GuideArea from "./GuideArea";

const Footer = () => {
  return (
    <footer id="colophon">
      <div className="guide-area bg-50 bottom border-tops-0">
        <GuideArea/>
      </div>
      <div className="footer-width-fixer">
        <div
          data-elementor-type="wp-post"
          data-elementor-id="1091"
          className="elementor elementor-1091"
        >
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-1de12e5 footer-area pt-130 pb-105 border border-top-0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="1de12e5"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no p-4">
                      {/* Col 1 */}
                      <div
                        className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-698ddad footer-single-item"
                        data-id="698ddad"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-5e7fe3a elementor-widget elementor-widget-image"
                            data-id="5e7fe3a"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container">
                              <img
                                width="118"
                                height="38"
                                src={IMAGES.logo}
                                className="attachment-full size-full wp-image-686"
                                alt="logo"
                              />
                            </div>
                          </div>

                          <div
                            className="elementor-element elementor-element-22caa49 elementor-widget elementor-widget-text-editor"
                            data-id="22caa49"
                            data-element_type="widget"
                            data-widget_type="text-editor.default"
                          >
                            <div className="elementor-widget-container">
                              <p className="p">With decades of experience, our firm has become a trusted name in business financing viz. offering smart, flexible, and rewarding loan solutions that drive lasting success.</p>
                            </div>
                          </div>

                          <div
                            className="elementor-element elementor-element-f15a2b8 elementor-widget elementor-widget-RaloSocialIcon"
                            data-id="f15a2b8"
                            data-element_type="widget"
                            data-widget_type="RaloSocialIcon.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="ps-0 mb-0 list-unstyled d-flex gap-4 flex-wrap social-link">
                                <li>
                                  <Link target="_blank" to={"https://www.facebook.com/people/EnvoCapital/61583407694538/"} rel="noopener noreferrer" >
                                    <i className="ri-facebook-fill" />
                                  </Link>
                                </li>
                                {/* <li>
                                  <Link target="_blank" to={"#"} rel="noopener noreferrer">
                                    <i className="ri-twitter-x-line" />
                                  </Link>
                                </li> */}
                                <li>
                                  <Link target="_blank" to={"https://www.linkedin.com/company/envo-capital/"} rel="noopener noreferrer">
                                    <i className="ri-linkedin-fill" />
                                  </Link>
                                </li>
                                <li>
                                  <Link target="_blank" to={"https://www.instagram.com/envo.capital/"} rel="noopener noreferrer">
                                    <i className="ri-instagram-line" />
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Col 2 */}
                      <div
                        className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-9540614"
                        data-id="9540614"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-8676b91 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-Ralo_FooterLinks"
                            data-id="8676b91"
                            data-element_type="widget"
                            data-widget_type="Ralo_FooterLinks.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="footer-single-item">
                                <h3>Quick Links</h3>
                                <ul className="ps-0 mb-0 list-unstyled additional-link">
                                  <li>
                                    <Link to="/about-us/">
                                      About Us
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/contact-us/">
                                      Contact Us
                                    </Link>
                                  </li>
                                  {/* <li>
                                    <Link to="/blog/">
                                      Blog
                                    </Link>
                                  </li> */}
                                  <li>
                                    <Link to="/faqs/">
                                      FAQ&#039;s
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Col 3 */}
                      <div
                        className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-21608f6"
                        data-id="21608f6"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-b8c232c elementor-widget__width-initial elementor-widget elementor-widget-Ralo_FooterLinks"
                            data-id="b8c232c"
                            data-element_type="widget"
                            data-widget_type="Ralo_FooterLinks.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="footer-single-item">
                                <h3>Services</h3>
                                <ul className="ps-0 mb-0 list-unstyled additional-link">
                                  <li>
                                    <Link to="/loan-program#Revenue-based-financing">
                                      Revenue-based financing
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/loan-program#SBA">
                                      SBA
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/loan-program#Term-Loans">
                                      Term Loans
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/loan-program#Line-of-Credit">
                                      Line of Credit
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Col 4 */}
                      <div
                        className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-afc2062"
                        data-id="afc2062"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-83d7072 elementor-widget__width-initial elementor-widget elementor-widget-Ralo_FooterLinks"
                            data-id="83d7072"
                            data-element_type="widget"
                            data-widget_type="Ralo_FooterLinks.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="footer-single-item">
                                <h3>Company</h3>
                                <ul className="ps-0 mb-0 list-unstyled additional-link">
                                  <li>
                                    <Link to="/terms-and-conditions/">
                                      Terms &amp; Condition
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/privacy-policy/">
                                      Privacy Policy
                                    </Link>
                                  </li>
                                  {/* <li>
                                    <Link to="/calculate-mortgage/">
                                      Calculate EMI
                                    </Link>
                                  </li> */}
                                  {/* <li>
                                    <Link to="/about-us/">
                                      History &amp; Fidelity
                                    </Link>
                                  </li> */}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Col 5 */}
                      <div
                        className="elementor-column elementor-col-20 elementor-inner-column elementor-element elementor-element-982bc33"
                        data-id="982bc33"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-483f4d1 elementor-widget elementor-widget-Ralo_Footer_ContactInfo"
                            data-id="483f4d1"
                            data-element_type="widget"
                            data-widget_type="Ralo_Footer_ContactInfo.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="footer-single-item">
                                <h3>Our Contact</h3>
                                <ul className="ps-0 mb-0 list-unstyled info-links">
                                  <li className="d-flex align-items-center">
                                    <i className="ri-mail-line" />
                                    {/* Cloudflare protected email markup kept as-is */}
                                    <Link to="mailto:info@envocapital.com">
                                      <span
                                        className="__cf_email__"
                                      >
                                        info@envocapital.com
                                      </span>
                                    </Link>
                                  </li>
                                  <li className="d-flex align-items-center">
                                    <i className="ri-phone-fill" />
                                    <Link to="tel:(800) 371-5360">(800) 371-5360</Link>
                                  </li>
                                  {/* <li className="d-flex align-items-center">
                                    <i className="ri-phone-fill" />
                                    <Link to="tel:+486445396533">+48 64453 96533</Link>
                                  </li> */}
                                  <li className="d-flex align-items-center">
                                    <i className="ri-calendar-2-line" />
                                    <span>Mon - Fri 10:00 AM - 6:00 PM</span>
                                  </li>
                                  <li className="d-flex align-items-center">
                                    <i className="ri-map-pin-line" />
                                    <span>12864 Biscayne Blvd #1018 North Miami , FL 33181</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
            </div>                 
          </section>

          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-237fd8d elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="237fd8d"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-30f1f65"
                data-id="30f1f65"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-97a15d3 elementor-widget elementor-widget-text-editor"
                    data-id="97a15d3"
                    data-element_type="widget"
                    data-widget_type="text-editor.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="copy-right-area">
                        <div className="container">
                          <div className="copy-right-content">
                            <p className="mb-0">
                              © EnvoCapital. All Rights Reserved by{" "}
                              <Link to="https://EnvoCapital.com/" target="_blank" rel="noopener noreferrer">
                                EnvoCapital
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
